





















































































import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import DuplicatesFilter from '@/components/Settings/Duplicates/DuplicatesFilter.vue'
import {ScrollButton} from "wings-ui-components";
import { DuplicateItem } from '@/store/settings/duplicates/types';
import BaseItemsPage from '../BaseItemsPage';

@Component({components: {DuplicatesFilter, ScrollButton}})
export default class Duplicates extends BaseItemsPage<DuplicateItem> {

  @Getter('duplicates') duplicatesResponse!: DuplicateItem[];

  is_show_filter = false;
  currentSort = 'id';
  currentSortOrder = 'desc';
  tableFields = this.tableFieldsDefault;

  getData(): DuplicateItem[] {
    return this.duplicatesResponse;
  }

  get tableFieldsDefault() {
    return ['transport', 'partner', 'template', 'timeout'];
  }
}
